// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c8yabNh85y5QjAfliUOC{font-size:16px;font-weight:600}.ORSv5wcEf71k6KKT33pl{font-size:13px;color:initial}`, "",{"version":3,"sources":["webpack://./src/components/cards/PendingSamCard/components/PendingSamCardBody/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,eAAA,CACF,sBACE,cAAA,CACA,aAAA","sourcesContent":[".title\n  font-size: 16px\n  font-weight: 600\n.creators\n  font-size: 13px\n  color: initial"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `c8yabNh85y5QjAfliUOC`,
	"creators": `ORSv5wcEf71k6KKT33pl`
};
export default ___CSS_LOADER_EXPORT___;
